import { useEffect } from 'react';
import BlocksTable from './ui/blocks-table';

const BlocksOverviewHome = () => {

    /**
     * Change title.
     */
    useEffect(() => {
        document.title = `Blocks | Productivity`;
    }, []);

    return (
        <div className="flex flex-col flex-1 leading-7 h-screen relative z-50 w-screen">
            <div className="overflow-auto">
                <div className="max-w-full mx-auto">

                    <BlocksTable/>

                </div>
            </div>
        </div>
    )

};

export default BlocksOverviewHome;